import { render } from "./QuestionList.vue?vue&type=template&id=35d33e6c&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=35d33e6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d33e6c"]])

export default __exports__